import { Link } from "react-router-dom";
import Header from "../landing/Header";
import Footer from "../landing/Footer";
import CookieBanner from "../landing/CookieBanner";
import useSeo from "../landing/useSeo";
import { DOCS, REQUISITES, SITE } from "../landing/siteConfig";
import "../landing/landing.css";

const Consent = () => {
    useSeo({
        title: `Согласие на обработку персональных данных — ${SITE.brand}`,
        description: `Текст согласия на обработку персональных данных, которое даёт пользователь сайта ${SITE.domain} при регистрации. Оператор — ${REQUISITES.shortName}.`,
        path: "/consent",
    });

    return (
        <div className="lp">
            <Header />
            <main className="doc">
                <div className="wrap wrap--narrow">
                    <nav className="crumbs" aria-label="Хлебные крошки">
                        <Link to="/">Главная</Link>
                        <span>/</span>
                        <span>Согласие на обработку персональных данных</span>
                    </nav>

                    <h1 className="doc__title">Согласие на обработку персональных данных</h1>
                    <p className="doc__meta">
                        Редакция от {DOCS.updated} · сайт {SITE.domain}
                    </p>

                    <div className="doc__note">
                        <p>
                            Регистрируя личный кабинет на сайте {SITE.domain}, вы принимаете
                            условия настоящего Согласия свободно, своей волей и в своём
                            интересе.
                        </p>
                    </div>

                    <h2>1. Оператор</h2>
                    <p>
                        {REQUISITES.legalName}, ОГРНИП {REQUISITES.ogrnip}, ИНН {REQUISITES.inn},
                        адрес: {REQUISITES.address} (далее — Оператор).
                    </p>

                    <h2>2. Перечень персональных данных</h2>
                    <p>
                        Согласие даётся на обработку следующих персональных данных,
                        самостоятельно указанных при регистрации личного кабинета на Сайте:
                    </p>
                    <ul>
                        <li>фамилия, имя;</li>
                        <li>адрес электронной почты, используемый в качестве логина;</li>
                        <li>пароль;</li>
                        <li>иные сведения, добровольно указанные в личном кабинете.</li>
                    </ul>

                    <h2>3. Цели обработки</h2>
                    <ul>
                        <li>регистрация и аутентификация в личном кабинете;</li>
                        <li>предоставление доступа к сервису покупки лидов и его функциям;</li>
                        <li>связь с вами по вопросам работы кабинета и кампаний;</li>
                        <li>заключение и исполнение договора в случае приобретения лидов.</li>
                    </ul>

                    <h2>4. Перечень действий с персональными данными</h2>
                    <p>
                        Согласие даётся на совершение следующих действий: сбор, запись,
                        систематизация, накопление, хранение, уточнение (обновление,
                        изменение), извлечение, использование, блокирование, удаление,
                        уничтожение персональных данных. Обработка осуществляется смешанным
                        способом — с использованием средств автоматизации и без их
                        использования.
                    </p>

                    <h2>5. Срок действия согласия</h2>
                    <p>
                        Согласие действует со дня его предоставления и до удаления аккаунта
                        либо достижения целей обработки, но не более 3 (трёх) лет с момента
                        прекращения использования личного кабинета, если иной срок не
                        установлен законодательством Российской Федерации или договором.
                    </p>

                    <h2>6. Порядок отзыва согласия</h2>
                    <p>
                        Согласие может быть отозвано в любой момент путём удаления аккаунта в
                        личном кабинете либо направлением обращения в свободной форме на адрес
                        электронной почты <a href={`mailto:${SITE.email}`}>{SITE.email}</a>. В
                        обращении необходимо указать фамилию, имя и контактные данные,
                        переданные через Сайт, чтобы Оператор мог вас идентифицировать.
                    </p>
                    <p>
                        После получения отзыва Оператор прекращает обработку и уничтожает
                        персональные данные в срок, не превышающий 30 (тридцати) дней, за
                        исключением сведений, обязанность хранения которых прямо предусмотрена
                        законом.
                    </p>

                    <h2>7. Передача третьим лицам</h2>
                    <p>
                        Оператор не передаёт персональные данные третьим лицам, кроме случаев,
                        предусмотренных законодательством Российской Федерации, и случаев
                        привлечения подрядчиков (хостинг-провайдер, сервис электронной почты,
                        оператор связи), действующих по поручению Оператора с соблюдением
                        требований конфиденциальности. Трансграничная передача не осуществляется.
                    </p>

                    <h2>8. Подтверждение</h2>
                    <p>Регистрируя личный кабинет, вы подтверждаете, что:</p>
                    <ul>
                        <li>
                            указанные данные принадлежат лично вам либо вы имеете полномочия на
                            их предоставление;
                        </li>
                        <li>
                            вы ознакомлены с{" "}
                            <Link to="/privacy">Политикой в отношении обработки персональных данных</Link>;
                        </li>
                        <li>вы достигли возраста, с которого вправе самостоятельно давать согласие;</li>
                        <li>согласие даётся свободно, своей волей и в своём интересе.</li>
                    </ul>

                    <p className="doc__back">
                        <Link to="/" className="btn btn--sm">
                            Вернуться на главную
                        </Link>
                    </p>
                </div>
            </main>
            <Footer />
            <CookieBanner />
        </div>
    );
};

export default Consent;
